/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useState, useCallback, useEffect } from "react";
import { isEmptyObject } from "../../../../utility/helpers";
import EmailItem from "./EmailItem";

const EmailList = ({ classes, emails, inquiryId, handleDownloadAttachment }) => {
	const [expanded, setExpanded] = useState({});

	const handleToggleEmail = useCallback((messageId) => {
		setExpanded((expanded) => {
			return {
				...expanded,
				[messageId]: !expanded[messageId],
			};
		});
	}, []);

	useEffect(() => {
		if (emails && emails.length > 0 && isEmptyObject(expanded)) {
			// open first email
			handleToggleEmail(emails[0].messageId);
		}
	}, [emails, expanded, handleToggleEmail]);

	return emails.map((email) => (
		<EmailItem
			classes={classes}
			key={email.messageId}
			email={email}
			inquiryId={inquiryId}
			isExpanded={expanded[email.messageId]}
			handleToggleEmail={handleToggleEmail}
			handleDownloadAttachment={handleDownloadAttachment}
		/>
	));
};

export default React.memo(EmailList);
